import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logEvent } from '../utils/analytics';
import './HeroSection.css';

function HeroSection() {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSend = () => {
    // Track hero CTA click
    logEvent('Landing Page', 'hero_send_clicked', {
      has_text: message.trim().length > 0,
      text_length: message.trim().length,
    });

    // Check if user is logged in
    const token = localStorage.getItem('token');

    if (token) {
      // User is logged in, redirect to dashboard
      navigate('/dashboard');
    } else {
      // User is not logged in, redirect to login page
      logEvent('Landing Page', 'hero_cta_conversion_attempt');
      navigate('/login');
    }
  };

  const handleInputFocus = () => {
    logEvent('Landing Page', 'hero_input_focused');
  };

  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  // Voice input - commented out for now
  // const handleVoice = () => {
  //   console.log('Voice input');
  //   // Handle voice input logic here
  // };

  return (
    <section className="hero-section" id="home">
      <div className="hero-color-splash-top"></div>
      <div className="hero-color-splash-bottom"></div>
      <div className="hero-content">
        <div className="hero-icon">
          <img src={process.env.PUBLIC_URL + '/icon.png'} alt="S.C.A.L.P.E.L. Medical Assistant" />
        </div>

        <h2 className="hero-greeting">
          Introducing S.C.A.L.P.E.L.<br />
          Simplified Clinical and Learning Platform for<br />
          Evidence-based Literature
        </h2>

        <p className="hero-description">
          Get instant answers to medical questions, generate case studies, and explore topics with AI-powered precision. Whether you're a student preparing for exams or a doctor in practice, find what you need in seconds.
        </p>

        <div className="chat-input-container">
          <div className="input-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.4" fill="none" xmlns="http://www.w3.org/2000/svg" color="#666">
              <path d="M8 15C12.8747 15 15 12.949 15 8C15 12.949 17.1104 15 22 15C17.1104 15 15 17.1104 15 22C15 17.1104 12.8747 15 8 15Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"></path>
              <path d="M2 6.5C5.13376 6.5 6.5 5.18153 6.5 2C6.5 5.18153 7.85669 6.5 11 6.5C7.85669 6.5 6.5 7.85669 6.5 11C6.5 7.85669 5.13376 6.5 2 6.5Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"></path>
            </svg>
          </div>
          <textarea
            className="chat-input"
            placeholder="Ask me anything..."
            value={message}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            onKeyPress={handleKeyPress}
            rows={4}
          />

          <div className="chat-actions">
            {/* Voice input - commented out for now */}
            {/* <button className="voice-btn" onClick={handleVoice}>
              <svg width="18" height="18" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
                <path d="M12 4L12 20" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M8 9L8 15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M20 10L20 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M4 10L4 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M16 7L16 17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
              Voice
            </button> */}

            <button className="send-btn" onClick={handleSend}>
              <svg width="18" height="18" viewBox="0 0 24 24" strokeWidth="1.4" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
                <path d="M22.1525 3.55321L11.1772 21.0044L9.50686 12.4078L2.00002 7.89795L22.1525 3.55321Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M9.45557 12.4436L22.1524 3.55321" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
              Send
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
